module.exports = __webpack_public_path__ + "static/img/cancel.fb92413.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cancel.png
// module id = rOFg
// module chunks = 1